module.exports = __webpack_public_path__ + "img/cleaned_toilet.77bba907.svg";